import { NgIf } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-image-slider-dialog',
	templateUrl: './image-slider-dialog.component.html',
	styleUrls: ['./image-slider-dialog.component.scss'],
	standalone: true,
	imports: [NgIf, MatButtonModule, MatIconModule],
})

export class ImageSliderDialogComponent implements OnInit {
	images: any[] = [];
	currentIndex = 0;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<ImageSliderDialogComponent>
	) {}

	ngOnInit() {
		this.images = this.data?.images || [];
		this.currentIndex = this.data?.clickedImage || 0;
	}

	prev() {
		if (this.currentIndex > 0) this.currentIndex--;
	}

	next() {
		if (this.currentIndex < this.images.length - 1) this.currentIndex++;
	}

	close() {
		this.dialogRef.close();
	}
}
